import(/* webpackMode: "eager" */ "/vercel/path0/packages/app/src/app/dashboard/pooled/page.tsx");
